import axios from 'axios';
import swal from "sweetalert";
import {
    loginConfirmedAction,
    Logout,
} from '../store/actions/AuthActions';
import { signIn } from '../api/api';

export function login(username, password) {
    return signIn({ username, password });
}

export function formatError(errorResponse) {
    return errorResponse?.message || 'Something went wrong';
}

export function saveTokenInLocalStorage(tokenDetails) {
    localStorage.setItem('userDetails', JSON.stringify({
        isAuthenticated: true,
        token: tokenDetails.token,
        user: tokenDetails.user,
        auth: {
            email: tokenDetails.user?.email || '',
            idToken: tokenDetails.token || '',
            localId: tokenDetails.user?._id || '',
            expiresIn: tokenDetails.user?.tokenExpiry || '',
            refreshToken: tokenDetails.user?.refreshToken || '',
        }
    }));
    
    // Also set the token in cookie
    document.cookie = `token=${tokenDetails.token}; path=/; secure; samesite=strict`;
}

export function checkAutoLogin(dispatch, navigate) {
    const tokenDetailsString = localStorage.getItem('userDetails');
    
    if (!tokenDetailsString) {
        dispatch(Logout(navigate));
        return;
    }

    try {
        const tokenDetails = JSON.parse(tokenDetailsString);
        if (!tokenDetails.token || !tokenDetails.isAuthenticated) {
            dispatch(Logout(navigate));
            return;
        }
        
        dispatch(loginConfirmedAction(tokenDetails));
    } catch (error) {
        console.error('Auto login error:', error);
        dispatch(Logout(navigate));
    }
}
